import { render, staticRenderFns } from "./Koutu_Questions.vue?vue&type=template&id=8acce2f8&scoped=true"
import script from "./Koutu_Questions.vue?vue&type=script&lang=js"
export * from "./Koutu_Questions.vue?vue&type=script&lang=js"
import style0 from "./Koutu_Questions.vue?vue&type=style&index=0&id=8acce2f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acce2f8",
  null
  
)

export default component.exports